import React, { Component } from "react";
import PropTypes from "prop-types";
import { getPhrase, Say } from "../../languages";
import { Message } from "wvus-forms";
import { setBrowserAutoFillUsed } from "../../helpers";

class InputControl extends Component {
  constructor(props) {
    super(props);
    const {
      fieldName,
      fieldValue = "",
      secondInteraction = false,
      isValid = false,
      validators = [],
      optional = false,
      formMethods
    } = this.props;

    formMethods.addFieldToState(
      fieldName,
      fieldValue,
      secondInteraction,
      isValid,
      validators,
      optional
    );

    this.previousValue = fieldValue;
  }

  render() {
    const {
      formMethods,

      fieldName,
      fieldId = fieldName,
      fieldClasses = "",
      fieldType = "text",
      fieldPlaceholder,
      fieldTitlePhraseKey,
      fieldState = formMethods.getFieldState(fieldName),
      characterCount,
      attributes = {},

      inputClasses = "",
      inputWrapperClasses = "",
      labelClasses = "",

      handleValueChange = formMethods.handleValueChange,
      handleBlur = formMethods.handleBlur,
      handleFocus = () => {},
      handleInput = (event) => {
        // With normal typing, input events will represent at most a single character (threshold 1).
        // But our phone field formatter adds () and a space at the fifth digit (so threshold 4).
        const characterChangeThreshold = 4;

        if (event.target.value.length - this.previousValue.length > characterChangeThreshold) {
          // Sets a session flag for analytics purposes.
          setBrowserAutoFillUsed();
        }

        this.previousValue = event.target.value;
      },
      showUISuccess = formMethods.showUISuccess(fieldState),
      showUIError = formMethods.showUIError(fieldState),
      hideMessage = false,
      successIcon,
      errorIcon,
      renderFieldPrefix = ""
    } = this.props;

    const { readOnly = false, disabled = false, ...restAttrs } = attributes;

    const validityClass = showUISuccess ? "has-success " : showUIError ? "has-error " : "";
    const label = !(fieldType === "hidden") ? (
      <label htmlFor={fieldName} className={labelClasses}>
        <Say phrase={fieldTitlePhraseKey} /> {!fieldState.optional && <sup>*</sup>}
      </label>
    ) : null;
    const fieldValue = fieldState.value || "";
    const fieldPrimaryClass = `wvus-field-${fieldName}`;

    return (
      <div
        className={`${fieldPrimaryClass} ${fieldClasses} form-group has-icon ${validityClass}`}
        data-field-container={fieldId}
        data-field-is-valid={fieldState.isValid}>
        {label}
        <div className={`form-control-wrapper ${inputWrapperClasses}`}>
          {renderFieldPrefix && renderFieldPrefix}
          <input
            id={fieldId || fieldName}
            className={`form-control ${inputClasses}`}
            value={fieldValue}
            name={fieldName}
            onBlur={handleBlur}
            onChange={handleValueChange}
            onFocus={handleFocus}
            onInput={handleInput}
            type={fieldType}
            data-phrase-key={fieldTitlePhraseKey}
            placeholder={`${fieldPlaceholder || getPhrase(fieldTitlePhraseKey)}${fieldState.optional ? "" : " *"}`}
            readOnly={readOnly}
            disabled={disabled}
            {...restAttrs}
          />
          {typeof characterCount !== "undefined" ? (
            <span className="message character-count">{characterCount}</span>
          ) : (
            ""
          )}
          {showUIError ? (
            <span data-phrase-key="cannot_translate:dynamic">
              <Message
                showError={true}
                showSuccess={false}
                message={fieldState.errorMessage}
                errorIcon={errorIcon}
                hideMessage={hideMessage}
              />
            </span>
          ) : (
            ""
          )}
          {showUISuccess ? (
            <Message
              showError={false}
              showSuccess={true}
              successIcon={successIcon}
              hideMessage={hideMessage}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

InputControl.propTypes = {
  fieldName: PropTypes.string.isRequired,
  renderFieldPrefix: PropTypes.element,
  formMethods: PropTypes.shape({
    handleBlur: PropTypes.func.isRequired,
    handleValueChange: PropTypes.func.isRequired,
    getFieldState: PropTypes.func.isRequired,
    addFieldToState: PropTypes.func.isRequired,
    showUIError: PropTypes.func.isRequired,
    showUISuccess: PropTypes.func.isRequired
  }).isRequired,
  attributes: PropTypes.shape({
    readonly: PropTypes.bool,
    disabled: PropTypes.bool
  }),
  validators: PropTypes.array
};

export default InputControl;
